import { createContext, useContext, useState, useCallback } from "react";
import { AppointmentDialog } from "@/components/AppointmentDialog";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openBooking = useCallback(() => setOpen(true), []);
  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <AppointmentDialog open={open} onOpenChange={setOpen} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  return ctx || { openBooking: () => {} };
};
